<template>
  <v-app  style="background-color:lightgray;">
    <Header/>
    <Side/>
    <v-content >
      <v-container class="fill-height">
        <v-snackbar
            v-model="installDialog"
            vertical
            color="white"
            :timeout="installDialogTimeout"
        >
          <p class="text--black">آیا این اپلیکیشن را نصب میکند؟</p>
          <br>
          <v-btn color="green" dark block rounded @click="installApp()">بله</v-btn>
          <v-btn color="red" text block @click="disMissInstall()">خیر</v-btn>
        </v-snackbar>
        <v-layout >
          <v-flex xs12 >
            <v-expand-transition name="fade-transform" mode="out-in">
              <div>
                <keep-alive>
                <router-view :key="$route.fullPath"/>
                </keep-alive>
                <Noti/>
                <Loading :isShow="loading"/>
<!--                <Progress/>-->
              </div>
            </v-expand-transition>
          </v-flex>

        </v-layout>
      </v-container>
    </v-content>
<!--    <Footer/>-->

  </v-app>

</template>

<script>
import { mapState} from "vuex";

export default {

  name: 'ContainerView',

  components: {
    Noti: () => import('../controls/Snackbar'),
    Loading: () => import('@/components/controls/Loading'),
    // Progress: () => import('../controls/Progress'),
    // Footer: () => import('./FootApp'),
    Header: () => import('./NavBar'),
    Side: () => import('./SideBar'),

  },
  data(){
    return{
      installDialog: false,
      installDialogTimeout: 10000,
      deferredPrompt: null
  }
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      if (this.isMobileCheck) {
        this.installDialog = true;
      }
    });
  },


  computed: {
    ...mapState('loader',['loading'],),
    ...mapState(['drawer', 'mini',]),
  },
    methods:{

      installApp() {
    this.installDialog = false;
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            this.installDialog = false;
          } else {
            this.installDialog = false;
          }
          this.deferredPrompt = null;
        });
  },

  disMissInstall() {
    this.installDialog = false
  }
},

}


</script>
<style>

hr.new5 {
  border: 1px solid orange;
  border-radius: 1px;

}


</style>
